import React from 'react';
import { connect } from 'react-redux';
import Translate from 'react-translate-component';
import { Col } from 'antd';

import { changeLanguage } from 'actions/appActions';
import { getCompanyInfo } from 'actions/asyncActions';

export const GuestLanguage = connect(null, { changeLanguage })(({ changeLanguage }) => (
    <a onClick={() => changeLanguage()}>
        <Translate content="guest.changeLanguage" />
    </a>
));

const GuestFooter = ({ children, company }) => {
    return (
        <div className="ant-row">
            <Col span={12}>
                { children }
            </Col>
            <Col span={12} className="text-right">
                { !company.isAncor && (
                    <GuestLanguage />
                )}
            </Col>
        </div>
    );
};

export default connect(state => ({ company: getCompanyInfo.selectData(state) }))(GuestFooter);
